import { render } from "./RegisteredTradesScrapingCreating.vue?vue&type=template&id=af2091e4&ts=true"
import script from "./RegisteredTradesScrapingCreating.vue?vue&type=script&lang=ts"
export * from "./RegisteredTradesScrapingCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__